import {
  PainDot as SharedPainDot,
  usePainRiskLabel as useSharedPainRiskLabel,
} from "@heraion/ui";
import type { Exercise, PainMap } from "@heraion/shared";

import { useShellProfile } from "./ThemeProfileBridge";

// Web mount of the shared @heraion/ui PainDot (lifted from mobile
// 2026-08-17, same day the "profile pain map is a mobile surface" comment
// in ExercisePickerMount.tsx went stale — painMap has been a web-rnw
// surface since the pain-map-picker lift, 2026-08-16). Mobile's twin
// (apps/mobile/src/bodymap/PainDot.tsx) sources painMap from
// ProfileContext; this sources it from useShellProfile(), the same read
// BodyScreen.tsx already uses for the picker itself.
export type PainDotProps = {
  exercise: Exercise;
  size?: number;
};

export function usePainRiskLabel(exercise: Exercise): string | null {
  const { doc } = useShellProfile();
  const painMap = doc?.["painMap"] as PainMap | undefined;
  return useSharedPainRiskLabel(exercise, painMap);
}

export function PainDot({ exercise, size }: PainDotProps) {
  const { doc } = useShellProfile();
  const painMap = doc?.["painMap"] as PainMap | undefined;
  return <SharedPainDot exercise={exercise} painMap={painMap} size={size} />;
}
